import { createClient } from '@supabase/supabase-js'

export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
export const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

console.log('🔧 Supabase Environment Check:');
console.log('🔧 VITE_SUPABASE_URL:', supabaseUrl ? 'Set' : 'Missing');
console.log('🔧 VITE_SUPABASE_ANON_KEY:', supabaseAnonKey ? 'Set' : 'Missing');

// Validate URL format
let isValidUrl = false;
if (supabaseUrl) {
  try {
    new URL(supabaseUrl);
    isValidUrl = true;
  } catch {
    isValidUrl = false;
  }
}

if (!supabaseUrl || !supabaseAnonKey) {
  const errorMessage = `
🚨 MISSING SUPABASE CONFIGURATION 🚨

Required environment variables are missing:
- VITE_SUPABASE_URL: ${supabaseUrl ? '✅ Set' : '❌ Missing'}  
- VITE_SUPABASE_ANON_KEY: ${supabaseAnonKey ? '✅ Set' : '❌ Missing'}

To fix this:
1. Copy .env.example to .env
2. Add your Supabase project URL and anon key
3. Restart the development server

Check the README.md for setup instructions.
  `;
  
  console.error(errorMessage);
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

if (!isValidUrl) {
  const errorMessage = `
🚨 INVALID SUPABASE URL 🚨

The VITE_SUPABASE_URL is not a valid URL format.
Current value: ${supabaseUrl}

Expected format: https://your-project-ref.supabase.co

To fix this:
1. Check your .env file
2. Ensure VITE_SUPABASE_URL follows the correct format
3. Restart the development server
  `;
  
  console.error(errorMessage);
  throw new Error('Invalid Supabase URL format. Please check your .env file.');
}
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  db: {
    schema: 'public'
  },
  global: {
    headers: {
      'x-client-info': 'snapalyze-web'
    }
  }
});

export type Database = {
  public: {
    Tables: {
      profiles: {
        Row: {
          id: string
          name: string
          email: string
          created_at: string
          updated_at: string
        }
        Insert: {
          id: string
          name: string
          email: string
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          name?: string
          email?: string
          created_at?: string
          updated_at?: string
        }
      }
      scans: {
        Row: {
          id: string
          user_id: string
          title: string
          description: string | null
          value: string | null
          ai_explanation: string | null
          image_url: string | null
          api_provider: string
          is_saved: boolean
          visual_matches: any
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          user_id: string
          title: string
          description?: string | null
          value?: string | null
          ai_explanation?: string | null
          image_url?: string | null
          api_provider: string
          is_saved?: boolean
          visual_matches?: any
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          user_id?: string
          title?: string
          description?: string | null
          value?: string | null
          ai_explanation?: string | null
          image_url?: string | null
          api_provider?: string
          is_saved?: boolean
          visual_matches?: any
          created_at?: string
          updated_at?: string
        }
      }
    }
  }
}
